export default __webpack_public_path__ + "static/media/line-angle-down-icon.a9f19105.svg";